/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { LayerPickerIconProps } from '../iconUtilities';

export const HumidityIcon = memo(({ 
    backgroundFillColor = '#82BC00',
    symbolFillColor = '#FFFFFF',
    width = 43,
    height = 43
}: LayerPickerIconProps) =>
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='12' cy='12' r='12' fill={backgroundFillColor} />
        <path fillRule='evenodd' clipRule='evenodd' d='M7.5402 14.5363C8.33451 11.0781 11.6636 5.4927 12.1247 3.99999C12.4567 5.505 15.8645 11.1857 16.4928 14.6617C16.9366 17.1239 15.2878 20.4462 12.1247 20.3995C9.06181 20.3577 6.97706 16.9831 7.5402 14.5363L12.9944 14.9745Z' fill={symbolFillColor}/>
    </svg>
);